import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Typography,
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  Business as BusinessIcon,
  Note as NoteIcon,
  Event as EventIcon,
  StickyNote2 as StickyNoteIcon,
  ShoppingCart as ShoppingCartIcon,
  Notifications as NotificationsIcon,
  Logout as LogoutIcon,
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';

const menuItems = [
  { text: 'DASHBOARD', icon: <DashboardIcon />, path: '/' },
  { text: 'USERS', icon: <PeopleIcon />, path: '/users' },
  { text: 'CORPORATIONS', icon: <BusinessIcon />, path: '/corporations' },
  { text: 'NOTICES', icon: <NoteIcon />, path: '/notices' },
  { text: 'EVENTS', icon: <EventIcon />, path: '/events' },
  { text: 'BOARD', icon: <StickyNoteIcon />, path: '/board' },
  { text: 'MERCHANTS', icon: <StickyNoteIcon />, path: '/merchants' },
  { text: 'MERCHANTS V2', icon: <StickyNoteIcon />, path: '/merchants-v2' },
  { text: 'SHOPPINGMALLS', icon: <ShoppingCartIcon />, path: '/shoppingmalls' },
  { text: 'PUSH NOTIFICATIONS', icon: <NotificationsIcon />, path: '/notifications' },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <Drawer 
      variant="permanent" 
      anchor="left"
      sx={{
        width: 240,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: 240,
          boxSizing: 'border-box',
        },
      }}
    >
      <Box
        sx={{
          padding: 2,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          gap: 2,
        }}
      >
        <Box
          component="img"
          src="/wwf-logo.png"
          alt="WWF Logo"
          sx={{
            width: '32px',
            height: '32px',
            objectFit: 'contain',
          }}
        />
        <Typography variant="h6" fontWeight="medium">
          클릭투기부
        </Typography>
      </Box>
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton 
              onClick={() => navigate(item.path)}
              selected={location.pathname === item.path}
              sx={{
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                },
                '&.Mui-selected': {
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  '& .MuiListItemIcon-root': {
                    color: 'primary.main',
                  },
                  '& .MuiListItemText-primary': {
                    color: 'primary.main',
                  },
                },
              }}
            >
              <ListItemIcon sx={{ color: 'inherit' }}>{item.icon}</ListItemIcon>
              <ListItemText primary={<span lang="en">{item.text}</span>} />
            </ListItemButton>
          </ListItem>
        ))}
        <ListItem disablePadding>
          <ListItemButton 
            onClick={handleLogout}
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
              '&.Mui-selected': {
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                '& .MuiListItemIcon-root': {
                  color: 'primary.main',
                },
                '& .MuiListItemText-primary': {
                  color: 'primary.main',
                },
              },
            }}
          >
            <ListItemIcon sx={{ color: 'inherit' }}><LogoutIcon /></ListItemIcon>
            <ListItemText primary={<span lang="en">LOGOUT</span>} />
          </ListItemButton>
        </ListItem>
      </List>
    </Drawer>
  );
};

export default Sidebar; 